import React, { useEffect, useState } from "react";
import { Card, Button, Spin, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import BonusService from "Services/EmployeeServices/BonusService";
import { BonusTypeEnumLabel } from "Constants/Enums/BonusTypeEnum";
import "./DashboardStats.scss";

const money = (v, c) =>
  v === null || v === undefined
    ? "-"
    : `${c ? `${c} ` : ""}${Number(v).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

// Bonus recommendations awaiting HR review (action items for the admin).
const DashboardPendingBonus = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const data = await BonusService.getPending();
        if (active) setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        if (active) setItems([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <Card
      title="Pending Bonus Approvals"
      className="dash-card"
      extra={
        items.length > 0 ? (
          <Button type="link" onClick={() => navigate("/payroll")}>
            Review
          </Button>
        ) : null
      }
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 30 }}>
          <Spin />
        </div>
      ) : items.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="All caught up" />
      ) : (
        items.slice(0, 5).map((b, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 0",
              borderBottom: "1px solid #f5f5f5",
            }}
          >
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 500, color: "#1f2937" }}>
                {BonusTypeEnumLabel[b.bonusType] || "Bonus"}
              </div>
              <div style={{ fontSize: 12, color: "#888" }}>{b.reason || "—"}</div>
            </div>
            <div style={{ fontWeight: 600, color: "#2E7D32", flexShrink: 0 }}>
              {money(b.amount, b.currency)}
            </div>
          </div>
        ))
      )}
    </Card>
  );
};

export default DashboardPendingBonus;
